import React from 'react';

import Button from './button';

// Icon button

export default ({onClick, icon, ...rest}) => <Button {...rest} justIcon icon={icon} onClick={onClick} />;
